// An uploaded file has no web address, but every bookmark row needs a URL
// (NOT NULL, and UNIQUE per user). Uploads get a synthetic one of the form
// `upload://<content hash>/<filename>` — the hash is what makes uploading the
// same file twice dedupe the same way saving the same page twice does.
//
// It is an identity, not a link: nothing can navigate to it, so anything that
// would render or fetch a bookmark's URL has to check for this first.

export const UPLOAD_URL_PREFIX = 'upload://';

export function isUploadUrl(url: string | null | undefined): boolean {
  return Boolean(url) && url!.startsWith(UPLOAD_URL_PREFIX);
}
